import React, { useEffect } from 'react';
import { 
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import * as classnames from 'classnames';
import jwt_decode from "jwt-decode";

import Dashboard from './pages/Dashboard';
import Login from './pages/Auth/Login';
import SignUp from './pages/Auth/SignUp';
import Info from './pages/Info';
import ResetPassword from './pages/Auth/ResetPassword';
import { signOut } from './app/actions/authActions';
import { showAlert } from './app/actions/uiActions';
import { getFirebase } from 'react-redux-firebase';

import { setUserDataForStripe } from './app/actions/stripeActions';
import { createUserDeviceId } from './app/actions/authActions';

import './app.scss';

const requireLogin = async(to, from, next) => {
  const firebase = getFirebase();

  if (to.meta.auth) {
    let decoded;
    const token = localStorage.getItem('unity_access');

    if(!token) {
      to.meta.dispatch(signOut());
      next.redirect('/login');
      return;
    };

    try {
      decoded = jwt_decode(token);
    } catch (error) {
      decoded = null;
    }
    
    if(decoded) {
      const currentDate = new Date().getTime();
      const dateExpiration = decoded.exp * 1000;
      const resultTime = ((dateExpiration - currentDate) / 1000).toFixed();
      
      if (resultTime > 1) {
        const tokenResult = await firebase.auth().currentUser.getIdTokenResult(true);
        localStorage.setItem('unity_access', tokenResult.token);
        next();
      } else {
        to.meta.dispatch(signOut());
        next.redirect('/login');
        to.meta.dispatch(showAlert({type:'error', message: 'Tokin not expirate'}));
      }
    } else {
      to.meta.dispatch(signOut());
      next.redirect('/login');
    }
  } else {
    next();
  };
};

function App() {
  const dispatch = useDispatch();
  const isLightFooter = useSelector((state) => state.ui.isLightFooter);
  const auth = useSelector((state) => state.firebase.auth);
  const userId = useSelector((state) => state.stripe.userData.userId);

  useEffect(() => {
    if(!auth.isEmpty && !userId) {
      dispatch(setUserDataForStripe({
        userId: auth.uid,
        email: auth.email
      }))
    }

    if(!auth.isEmpty) {
      dispatch(createUserDeviceId(auth.uid))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[auth])

  return (
    <Router>
      <div 
        className={classnames('app',{
          'app--light': isLightFooter
        })}
      >
        <GuardProvider guards={[requireLogin]}>
          <Switch>
            <Route path="/login" component={Login}/>
            <Route path="/sign-up" component={SignUp}/>
            <Route path="/reset-password" component={ResetPassword}/>
            <Route path="/info/:id?" component={Info}/>
            <GuardedRoute path="/" meta={{auth: true,dispatch}}>
              <Dashboard />
            </GuardedRoute>
          </Switch>
        </GuardProvider>
      </div>
    </Router>
  );
};

export default App;
